<template>
  <div>
    <div style="text-align:right">
      <a href="/#/appts/schedule"><i class="fa-solid fa-calendar"></i></a
      >&nbsp;&nbsp;
      <a href="/#/appts"><i class="fa-solid fa-list"></i></a>
    </div>
    <Schedule />
  </div>
</template>

<script>
import Schedule from "@/views/Components/Appt/Appts/Schedule.vue";
export default { components: { Schedule } };
</script>

<style></style>
